//* BREAK Start*/
export const GROUP_INSIGHT_REPORT_INITIAL = "GROUP_INSIGHT_REPORT_INITIAL";
export const GROUP_INSIGHT_REPORT_PROCESS = "GROUP_INSIGHT_REPORT_PROCESS";
export const GROUP_INSIGHT_REPORT_SUCCESS = "GROUP_INSIGHT_REPORT_SUCCESS";
export const GROUP_INSIGHT_REPORT_FAILED = "GROUP_INSIGHT_REPORT_FAILED";

//* BREAK End*/
